import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faTiktok, faXTwitter } from "@fortawesome/free-brands-svg-icons";

const SocialMediaLinks = () => {
  return (
    <div className="secretaria-redes">
      <a href="https://www.facebook.com/CAASIMcomunicacion/" target="_blank" rel="noreferrer">
        <FontAwesomeIcon icon={faFacebookF} size="lg"/>
      </a>

      {/* <a href="https://www.instagram.com/culturadelagua_caasim/" target="_blank" rel="noreferrer">
        <FontAwesomeIcon icon={faInstagram} size="lg"/>
      </a> */}

      <a href="https://twitter.com/CAASIM" target="_blank" rel="noreferrer">
        <FontAwesomeIcon icon={faXTwitter} size="lg"/>
      </a>
      

      <a href="https://www.tiktok.com/@gotintita" target="_blank" rel="noreferrer">
        <FontAwesomeIcon icon={faTiktok} size="lg"/>
      </a>
    </div>
  );
};

export default SocialMediaLinks;